import { useEffect, useState } from 'react'
import { api } from '../api'

export interface ViewerItem {
  sha: string
  mime: string
  caption?: string
}

// Visor em tela cheia das capturas do exame: foto ampliada ou vídeo com
// controles. Setas trocam de item; Esc fecha.
export function MediaViewer({ items, index, onIndex, onClose, onEdit }: {
  items: ViewerItem[]
  index: number
  onIndex: (i: number) => void
  onClose: () => void
  // quando presente, fotos ganham o botão Editar
  onEdit?: (index: number) => void
}) {
  const item = items[index]
  const isVideo = !!item && item.mime.startsWith('video/')
  const [src, setSrc] = useState('')

  useEffect(() => {
    let alive = true
    setSrc('')
    if (!item) return
    api.media.signedUrl(item.sha).then((url) => { if (alive) setSrc(url) }).catch(() => undefined)
    return () => { alive = false }
  }, [item?.sha])

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopPropagation(); onClose() }
      if (e.key === 'ArrowRight' && index < items.length - 1) onIndex(index + 1)
      if (e.key === 'ArrowLeft' && index > 0) onIndex(index - 1)
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [index, items.length, onClose, onIndex])

  if (!item) return null
  const arrow: React.CSSProperties = {
    position: 'absolute', top: '50%', transform: 'translateY(-50%)', width: 44, height: 64, border: 'none',
    borderRadius: 8, background: 'rgba(255,255,255,.08)', color: '#e6eef3', font: '300 30px/1 var(--font-sans)', cursor: 'pointer',
  }

  return (
    <div onClick={onClose} data-viewer="1"
      style={{ position: 'fixed', inset: 0, zIndex: 60, background: 'rgba(6,9,11,.94)', display: 'flex', flexDirection: 'column' }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ flex: 'none', height: 48, display: 'flex', alignItems: 'center', gap: 12, padding: '0 14px', color: '#cfdae1' }}>
        <span style={{ font: '500 12px/1 var(--font-mono)' }}>{index + 1} / {items.length}</span>
        <span style={{ flex: 1, font: '400 13px/1.2 var(--font-sans)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.caption}</span>
        {onEdit && !isVideo && (
          <button className="btn" onClick={() => onEdit(index)}
            style={{ height: 30, background: 'transparent', color: '#e6eef3', borderColor: 'rgba(255,255,255,.18)' }}>
            Editar
          </button>
        )}
        <button className="btn" onClick={onClose}
          style={{ height: 30, background: 'transparent', color: '#e6eef3', borderColor: 'rgba(255,255,255,.18)' }}>
          Fechar
        </button>
      </div>
      <div style={{ flex: 1, minHeight: 0, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 64px 20px' }}>
        {src && (isVideo ? (
          <video key={item.sha} src={src} controls autoPlay onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 6, background: '#000' }} />
        ) : (
          <img key={item.sha} src={src} alt={item.caption || 'captura'} onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 6 }} />
        ))}
        {index > 0 && (
          <button onClick={(e) => { e.stopPropagation(); onIndex(index - 1) }} style={{ ...arrow, left: 10 }}>‹</button>
        )}
        {index < items.length - 1 && (
          <button onClick={(e) => { e.stopPropagation(); onIndex(index + 1) }} style={{ ...arrow, right: 10 }}>›</button>
        )}
      </div>
    </div>
  )
}
